/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
module.exports = function isObject(val) {
    return val != null && (typeof val === "undefined" ? "undefined" : _type_of(val)) === 'object' && Array.isArray(val) === false;
};
